"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Type = void 0;
var Type;
exports.Type = Type;

(function (Type) {
  Type[Type["SHARE_TYPE_USER"] = 0] = "SHARE_TYPE_USER";
  Type[Type["SHARE_TYPE_GROUP"] = 1] = "SHARE_TYPE_GROUP";
  Type[Type["SHARE_TYPE_LINK"] = 3] = "SHARE_TYPE_LINK";
  Type[Type["SHARE_TYPE_EMAIL"] = 4] = "SHARE_TYPE_EMAIL";
  Type[Type["SHARE_TYPE_REMOTE"] = 6] = "SHARE_TYPE_REMOTE";
  Type[Type["SHARE_TYPE_CIRCLE"] = 7] = "SHARE_TYPE_CIRCLE";
  Type[Type["SHARE_TYPE_GUEST"] = 8] = "SHARE_TYPE_GUEST";
  Type[Type["SHARE_TYPE_REMOTE_GROUP"] = 9] = "SHARE_TYPE_REMOTE_GROUP";
  Type[Type["SHARE_TYPE_ROOM"] = 10] = "SHARE_TYPE_ROOM";
  Type[Type["SHARE_TYPE_DECK"] = 12] = "SHARE_TYPE_DECK";
})(Type || (exports.Type = Type = {}));
//# sourceMappingURL=index.js.map